export const GET_SHIFT_SUMMARY_SUCCESS = 'GET_SHIFT_SUMMARY_SUCCESS';
export const GET_SHIFT_SUMMARY_FAIL = 'GET_SHIFT_SUMMARY_FAIL';
export const SET_GET_SHIFT_SUMMARY_LOADING = 'SET_GET_SHIFT_SUMMARY_LOADING';

export const GET_DAILY_SUMMARY_SUCCESS = 'GET_DAILY_SUMMARY_SUCCESS';
export const GET_DAILY_SUMMARY_FAIL = 'GET_DAILY_SUMMARY_FAIL';
export const SET_GET_DAILY_SUMMARY_LOADING = 'SET_GET_DAILY_SUMMARY_LOADING';

export const GET_DAILY_CHART_SUCCESS = 'GET_DAILY_CHART_SUCCESS';
export const GET_DAILY_CHART_FAIL = 'GET_DAILY_CHART_FAIL';
export const SET_GET_DAILY_CHART_LOADING = 'SET_GET_DAILY_CHART_LOADING';

export const GET_PAYMENT_LEDGER_SUCCESS = 'GET_PAYMENT_LEDGER_SUCCESS';
export const GET_PAYMENT_LEDGER_FAIL = 'GET_PAYMENT_LEDGER_FAIL';
export const SET_GET_PAYMENT_LEDGER_LOADING = 'SET_GET_PAYMENT_LEDGER_LOADING';

export const GET_PAYMENT_LEDGER_METHODS_SUCCESS =
  'GET_PAYMENT_LEDGER_METHODS_SUCCESS';
export const GET_PAYMENT_LEDGER_METHODS_FAIL = 'GET_PAYMENT_LEDGER_METHODS_FAIL';
export const SET_GET_PAYMENT_LEDGER_METHODS_LOADING =
  'SET_GET_PAYMENT_LEDGER_METHODS_LOADING';

export const GET_BUSINESS_DAY_PARTICIPATION_SUCCESS =
  'GET_BUSINESS_DAY_PARTICIPATION_SUCCESS';
export const GET_BUSINESS_DAY_PARTICIPATION_FAIL =
  'GET_BUSINESS_DAY_PARTICIPATION_FAIL';
export const SET_GET_BUSINESS_DAY_PARTICIPATION_LOADING =
  'SET_GET_BUSINESS_DAY_PARTICIPATION_LOADING';
